var _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnCurLo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "btn_cur_lo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map-maps-and-location-svgrepo-com",
    transform: "translate(-24.72 -58.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4202",
    "data-name": "\\uD328\\uC2A4 4202",
    d: "M101.32,100.757a1.17,1.17,0,0,0-.895-.242l-12.782,1.8-17.7-2.853-14.339,2.685a1.066,1.066,0,0,0-.9,1.026v25.141a1.022,1.022,0,0,0,.409.809,1.174,1.174,0,0,0,.927.217l13.9-2.6,17.7,2.853,13.113-1.842a1.07,1.07,0,0,0,.952-1.034V101.55A1.02,1.02,0,0,0,101.32,100.757Z",
    transform: "translate(-23.988 -18.868)",
    fill: "#eda637"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4203",
    "data-name": "\\uD328\\uC2A4 4203",
    d: "M220.655,129.585l-17.7-2.853V99.457l17.7,2.853Z",
    transform: "translate(-157 -18.868)",
    fill: "#f7dc4d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_479",
    "data-name": "\\uD0C0\\uC6D0 479",
    cx: 8.419,
    cy: 3.66,
    rx: 8.419,
    ry: 3.66,
    transform: "translate(46.094 94.609)",
    fill: "#5289c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4206",
    "data-name": "\\uD328\\uC2A4 4206",
    d: "M23.809,156.162a11.9,11.9,0,1,0-23.809,0c0,4.667,6.964,14.826,10.24,19.346a2.061,2.061,0,0,0,3.335,0C16.852,171.006,23.809,160.888,23.809,156.162Z",
    transform: "translate(42.433 -79.719)",
    fill: "#de3b35"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_478",
    "data-name": "\\uD0C0\\uC6D0 478",
    cx: 5.039,
    cy: 5.039,
    r: 5.039,
    transform: "translate(49.18 71.403)",
    fill: "#3c3c3c"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1210",
    "data-name": "\\uC0AC\\uAC01\\uD615 1210",
    width: 58,
    height: 58,
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCurLo);
export default __webpack_public_path__ + "static/media/btn_cur_lo.524475e8d5c52e8f01fd10430cc09013.svg";
export { ForwardRef as ReactComponent };